interface Props { cs: boolean }

function CsBody() {
  return (
    <>
      <p>
        ShowX má slot pro modul <strong>EventX Bridge</strong>, který propojí FOH show management s EventX
        eventy na pódiu — wordcloudy, ankety, kvízy a další interaktivní aktivity.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">Aktuální stav (v0.8.0)</h3>
      <p>
        <strong>EventX Bridge modul je v ShowX naplánován, ale zatím nebyl implementován.</strong> Absorpce
        BridgeX 0.3.x do ShowX je zařazena v bundlu B002 (Q3 2026). Do té doby platí:
      </p>
      <ul>
        <li>
          Pro mapování EventX aktivit na OSC/MIDI/DMX výstupy používej{' '}
          <strong>standalone BridgeX 0.3.x</strong> — samostatnou aplikaci, která dnes tuto funkci plně
          obstarává.
        </li>
        <li>
          ShowX a BridgeX mohou běžet na stejném FOH Macu vedle sebe. BridgeX naslouchá na EventX Supabase
          realtime kanálu a dispatche výstupy přes OutputDispatcher.
        </li>
        <li>
          Podrobný návod k BridgeX viz{' '}
          <a href="https://eventx.xlabproject.net/prirucka" target="_blank" rel="noreferrer" className="text-accent-deep underline underline-offset-2">
            EventX příručka, kapitola 8
          </a>{' '}
          (<code>eventx.xlabproject.net/prirucka</code>).
        </li>
      </ul>

      <h3 className="display-serif text-xl mt-10 mb-3">Co přinese modul po implementaci (B002)</h3>
      <p>
        Po dokončení absorpce (Q3 2026) EventX Bridge modul v ShowX bude:
      </p>
      <ul>
        <li>
          Načten ShowX shell jako standardní modul — žádná separátní aplikace.
        </li>
        <li>
          Subscribovat na EventX Supabase real-time kanál pro živé eventy (activities: wordcloud, poll,
          quiz_mc, hundred_points, scales, qa, sensor_race, show_control atd.).
        </li>
        <li>
          Dispatchovat OSC/MIDI/DMX výstupy přes společný OutputDispatcher (stejný jako Cuelist Core).
        </li>
        <li>
          Zachovat 100% funkční paritu s BridgeX 0.3.x — byte-identické OSC pakety.
        </li>
        <li>
          Migrace konfigurace z BridgeX profilů do ShowX persistedConfig přes migrační skript.
        </li>
      </ul>
      <p>
        <strong>Dokud modul v ShowX neexistuje, nepřidávej ho do konfigurací jako dostupný.</strong> Tento
        manuál bude aktualizován po přijetí B002.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">Paralelní provoz ShowX + BridgeX dnes</h3>
      <p>
        Typické nastavení pro produkce s EventX interakcemi:
      </p>
      <ol>
        <li>FOH Mac spustí <strong>ShowX</strong> — cuelist, GO, dispatch.</li>
        <li>
          FOH Mac spustí <strong>BridgeX</strong> — EventX modul, OSC/MIDI/DMX pro interaktivní aktivity.
        </li>
        <li>
          Oba sdílejí síť a připojené zařízení; OSC porty nesmí kolidovat (zkontroluj nastavení v BridgeX +
          routing table v ShowX).
        </li>
      </ol>
    </>
  )
}

function EnBody() {
  return (
    <>
      <p>
        ShowX has a slot for the <strong>EventX Bridge</strong> module, which will connect FOH show management
        to EventX events on stage — word clouds, polls, quizzes, and other interactive activities.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">Current status (v0.8.0)</h3>
      <p>
        <strong>The EventX Bridge module in ShowX is planned, but not yet implemented.</strong> The absorption
        of BridgeX 0.3.x into ShowX is scheduled in bundle B002 (Q3 2026). Until then:
      </p>
      <ul>
        <li>
          To map EventX activities to OSC/MIDI/DMX outputs, use{' '}
          <strong>standalone BridgeX 0.3.x</strong> — the separate application that currently handles this
          function completely.
        </li>
        <li>
          ShowX and BridgeX can run side by side on the same FOH Mac. BridgeX listens to the EventX Supabase
          realtime channel and dispatches outputs via its OutputDispatcher.
        </li>
        <li>
          For detailed BridgeX setup, see{' '}
          <a href="https://eventx.xlabproject.net/prirucka" target="_blank" rel="noreferrer" className="text-accent-deep underline underline-offset-2">
            EventX handbook, chapter 8
          </a>{' '}
          (<code>eventx.xlabproject.net/prirucka</code>).
        </li>
      </ul>

      <h3 className="display-serif text-xl mt-10 mb-3">What the module will add after B002</h3>
      <p>
        After the absorption is complete (Q3 2026), the EventX Bridge module in ShowX will:
      </p>
      <ul>
        <li>
          Load into the ShowX shell as a standard module — no separate app.
        </li>
        <li>
          Subscribe to the EventX Supabase real-time channel for live events (activities: wordcloud, poll,
          quiz_mc, hundred_points, scales, qa, sensor_race, show_control, etc.).
        </li>
        <li>
          Dispatch OSC/MIDI/DMX outputs via the shared OutputDispatcher (same as Cuelist Core).
        </li>
        <li>
          Maintain 100% functional parity with BridgeX 0.3.x — byte-identical OSC packets.
        </li>
        <li>
          Migrate configuration from BridgeX profiles to ShowX persistedConfig via a migration script.
        </li>
      </ul>
      <p>
        <strong>While the module doesn't exist in ShowX yet, don't add it to configurations as available.</strong>{' '}
        This manual will be updated when B002 is accepted.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">Running ShowX + BridgeX in parallel today</h3>
      <p>Typical setup for productions with EventX interactions:</p>
      <ol>
        <li>FOH Mac launches <strong>ShowX</strong> — cuelist, GO, dispatch.</li>
        <li>
          FOH Mac launches <strong>BridgeX</strong> — EventX module, OSC/MIDI/DMX for interactive activities.
        </li>
        <li>
          Both share the network and connected devices; OSC ports must not collide (check settings in BridgeX +
          the routing table in ShowX).
        </li>
      </ol>
    </>
  )
}

export default function Chapter7({ cs }: Props) {
  return (
    <article id="kap-7" className="scroll-mt-24">
      <h2 className="display-serif text-display-2 leading-tight mb-8">
        {cs ? '7. EventX Bridge modul' : '7. EventX Bridge module'}
      </h2>
      <div className="copy prose-guide max-w-none">
        {cs ? <CsBody /> : <EnBody />}
      </div>
    </article>
  )
}
